export const NEWSLETTER_SERVICE_HOST = 'https://newsletter-subscription-service-234667209142.europe-west1.run.app';

export const NEWSLETTER_PATHS = {
  newsletterEmails: `${NEWSLETTER_SERVICE_HOST}/api/messages`,
  newsletterDomains: `${NEWSLETTER_SERVICE_HOST}/api/domains`,
};
